// extracted by mini-css-extract-plugin
export default {"cardWrapper":"CategoryCards-module__cardWrapper--bZT5S"};